import { render, staticRenderFns } from "./BonuspointsView.vue?vue&type=template&id=2205d47c&scoped=true"
import script from "./BonuspointsView.vue?vue&type=script&lang=ts"
export * from "./BonuspointsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205d47c",
  null
  
)

export default component.exports